import {
  LayoutDashboard, Inbox, Boxes, Wrench, CalendarDays, Cog, Workflow,
  Trash2, Truck, FileCheck, Building2, FileText, ShieldCheck, History,
  Users, Settings as SettingsIcon, ClipboardList, KanbanSquare,
  FolderOpen, FileSignature, PackageSearch, GraduationCap, GitCompare, Gauge, Ruler,
} from "lucide-react";

// Internal nav items, each gated by a permission module.
const ITEMS = [
  { group: "Operations", module: "dashboard", path: "/app/dashboard", icon: LayoutDashboard, label: "Dashboard" },
  { group: "Operations", module: "job_flow", path: "/app/job-flow", icon: KanbanSquare, label: "Job Flow Board" },
  { group: "Operations", module: "technical_dashboard", path: "/app/technical-dashboard", icon: Gauge, label: "Technical Dashboard" },
  { group: "Operations", module: "equipment", path: "/app/equipment", icon: Boxes, label: "Equipment Register" },
  { group: "Operations", module: "due", path: "/app/due", icon: CalendarDays, label: "Calibration Due" },
  { group: "Operations", module: "rfqs", path: "/app/rfqs", icon: Inbox, label: "RFQ Inbox" },
  { group: "Operations", module: "scrapped", path: "/app/scrapped", icon: Trash2, label: "Unserviceable / Defective" },

  { group: "Workflow", module: "receiving", path: "/app/receiving", icon: Inbox, label: "Receiving / New Job" },
  { group: "Workflow", module: "active_lab", path: "/app/active-lab", icon: ClipboardList, label: "Active Lab" },
  { group: "Workflow", module: "worklist", path: "/app/worklist", icon: Wrench, label: "My Worklist" },
  { group: "Workflow", module: "parts", path: "/app/parts", icon: Cog, label: "Awaiting Spares" },
  { group: "Workflow", module: "subcontractor", path: "/app/subcontractor", icon: Workflow, label: "Subcontractor" },
  { group: "Workflow", module: "dispatch", path: "/app/dispatch", icon: Truck, label: "Dispatch" },

  { group: "Records", module: "certificates", path: "/app/certificates", icon: FileCheck, label: "Certificates" },
  { group: "Records", module: "standards", path: "/app/standards", icon: Ruler, label: "PTE Standards" },
  { group: "Records", module: "customers", path: "/app/customers", icon: Building2, label: "Customers" },
  { group: "Records", module: "subcontractor", path: "/app/subcontractor-register", icon: Workflow, label: "Subcontractors" },
  { group: "Records", module: "documents", path: "/app/documents", icon: FolderOpen, label: "Documents" },
  { group: "Records", module: "forms", path: "/app/forms", icon: FileSignature, label: "Signed Forms" },
  { group: "Records", module: "sops", path: "/app/sops", icon: GraduationCap, label: "SOP / Training" },
  { group: "Records", module: "reports", path: "/app/reports", icon: FileText, label: "Reports" },
  { group: "Records", module: "reconciliation", path: "/app/reconciliation", icon: GitCompare, label: "Reconciliation" },
  { group: "Records", module: "stock_register", path: "/app/stock-register", icon: PackageSearch, label: "Stock Register" },
  { group: "Records", module: "audit", path: "/app/audit", icon: ShieldCheck, label: "Audit Log" },

  { group: "Administration", module: "users", path: "/app/users-permissions", icon: Users, label: "Users & Permissions" },
  { group: "Administration", module: "settings", path: "/app/settings", icon: SettingsIcon, label: "Settings" },
];

const CUSTOMER_ITEMS = [
  { group: "My Account", module: "portal", path: "/app/portal", icon: Boxes, label: "My Equipment" },
  { group: "My Account", module: "request_quote", path: "/app/request-quote", icon: Inbox, label: "Request a Quote" },
  { group: "My Account", module: "my_certificates", path: "/app/my-certificates", icon: FileCheck, label: "Certificates" },
  { group: "My Account", module: "history", path: "/app/history", icon: History, label: "Calibration History" },
  { group: "My Account", module: "documents", path: "/app/portal-documents", icon: FolderOpen, label: "Documents" },
  { group: "My Account", module: "forms", path: "/app/portal-forms", icon: FileSignature, label: "Forms to Sign" },
];

export function buildNav(perms, isCustomer) {
  const items = isCustomer ? CUSTOMER_ITEMS : ITEMS;
  const visible = items.filter((it) => {
    if (!perms || !perms[it.module] || !perms[it.module].view) return false;
    // SOP/Training only clutters the sidebar for staff who can author them;
    // everyone else reaches it via the "Help / Learn" button in the topbar.
    if (it.module === "sops" && !perms[it.module].edit) return false;
    return true;
  });
  const groups = [];
  for (const it of visible) {
    let g = groups.find((x) => x.label === it.group);
    if (!g) { g = { label: it.group, items: [] }; groups.push(g); }
    g.items.push(it);
  }
  return groups;
}

export function firstPath(perms, isCustomer) {
  const groups = buildNav(perms, isCustomer);
  if (groups[0] && groups[0].items[0]) return groups[0].items[0].path;
  return isCustomer ? "/app/portal" : "/app/dashboard";
}

export function navKey(user) {
  if (user?.user_type === "customer") return "customer";
  return user?.role || "manager";
}
